import { uiSurface } from "shared/ui/uiSurface"
import { Box, Paper, Stack } from "@mui/material"
import { APIProvider } from "@vis.gl/react-google-maps"
import { FC } from "react"
import { appConstants } from "../../shared-module/constants"
import { DispatcherRouteList } from "./DispatcherRouteList"
import { RoutePlanningMap } from "./RoutePlanningMap"

export const RoutePlanningContainer: FC = () => {
  return (
    <APIProvider apiKey={appConstants.googleMapKey}>
      <Box>
        <Stack
          direction={"row"}
          height={`calc(100vh - ${appConstants.mainAppBarHeight + 20}px)`}
          width={"100%"}
          spacing={2}
        >
          <Paper
            {...uiSurface("UI-DSP-041")}
            data-testid="route-planning-list-panel"
            sx={{
              padding: 1,
              width: "30%",
              height: "100%",
              borderRadius: 2,
            }}
          >
            <DispatcherRouteList />
          </Paper>
          <Paper
            {...uiSurface("UI-DSP-045")}
            data-testid="route-planning-map-panel"
            sx={{
              width: "70%",
              borderRadius: 2,
            }}
          >
            <RoutePlanningMap />
          </Paper>
        </Stack>
      </Box>
    </APIProvider>
  )
}
